import { render, staticRenderFns } from "./CockpitVendas.vue?vue&type=template&id=63c156d2&scoped=true"
import script from "./CockpitVendas.vue?vue&type=script&lang=js"
export * from "./CockpitVendas.vue?vue&type=script&lang=js"
import style0 from "./CockpitVendas.vue?vue&type=style&index=0&id=63c156d2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63c156d2",
  null
  
)

export default component.exports